module.exports = __webpack_public_path__ + "site/img/indexnewyear1zh.c19d574a.jpg";